var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12",
        },
        [
          _c(
            "div",
            {
              staticClass: "container small",
              staticStyle: { "margin-top": "30px" },
              attrs: { "data-test-id": "SigninView" },
            },
            [
              _c("div", { staticClass: "border-box" }, [
                _vm.isStepForm
                  ? _c("div", [
                      _c("h3", { staticClass: "fg-color-blue" }, [
                        _vm._v("Request an account"),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          attrs: { type: "button" },
                          on: { click: _vm.handleNext },
                        },
                        [_vm._v("Next")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isStepWorkspaces
                  ? _c("div", [
                      _c("h3", { staticClass: "fg-color-blue" }, [
                        _vm._v("Select workspaces"),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-lg btn-block",
                          attrs: { type: "button" },
                          on: { click: _vm.handleNext },
                        },
                        [_vm._v("Send request")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._m(4),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("br"),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "Email" } }, [_vm._v("Email:")]),
      _vm._v(" "),
      _c("input", { staticClass: "form-control", attrs: { type: "email" } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "error",
        attrs: { "data-bind": "text: EmailError" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "FirstName" } }, [_vm._v("First name:")]),
      _vm._v(" "),
      _c("input", { staticClass: "form-control", attrs: { type: "text" } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "error",
        attrs: { "data-bind": "text: FirstNameError" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "LastName" } }, [_vm._v("Last name:")]),
      _vm._v(" "),
      _c("input", { staticClass: "form-control", attrs: { type: "text" } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "error",
        attrs: { "data-bind": "text: LastNameError" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "list-group" }, [
      _c("li", { staticClass: "list-group-item" }, [
        _c("strong", [_vm._v("Default")]),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
        ]),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-group-item" }, [
        _c("strong", [_vm._v("Prioritization 2021")]),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
        ]),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-group-item" }, [
        _c("strong", [_vm._v("Prioritization 2022")]),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
        ]),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-group-item" }, [
        _c("strong", [_vm._v("Playground")]),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
        ]),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "list-group-item" }, [
        _c("strong", [_vm._v("Secret")]),
        _c("br"),
        _vm._v(" "),
        _c("small", [
          _vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", [
      _c("span", [_vm._v("Already have an account?")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "/#/organizations/users/signin" } }, [
        _vm._v("Sign-in"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }